import templateUrl from './set-user-password.component.html';

/**
 * A component that displays a form for changing another user's password.
 */
export const SetUserPasswordComponent = {
    templateUrl,
    require: {
        editForm: "?^^form"
    },
    bindings: {
        user: "<"
    },
    controller: class SetUserPasswordComponent {
        constructor(passwordValidatorService, utilityService) {
            'ngInject';
            this.passwordValidatorService = passwordValidatorService;
            this.utilityService = utilityService;
        }

        $onChanges(changesObj) {
            if (changesObj.user && this.user) {
                this._loadValidator();
            }
        }

        onChangeSendUserPassword() {
            if (this.sendUserPassword) {
                this.user.Password = this.customUserPassword;
            } else {
                this.customUserPassword = this.user.Password;
                this.user.Password = null;
            }
        }

        onChangePassword() {
            const matched = this.user.Password === this.confirmPassword;

            if (this.editForm) {
                this.editForm.ConfirmPassword.$setValidity("matched", matched);
            }
        }

        /**
         * Load the validator for the component's user.
         */
        _loadValidator() {
            const validatorLoaded = this.passwordValidatorService.retrievePasswordValidator(this.user)
                .then(validator => this.passwordValidator = validator)
                // Suppress errors loading the validator.
                .catch(ex => console.error(ex));
            this.utilityService.showLoadingUntilResolved(validatorLoaded);
        }

    }
};
